var map = {
	"./templalteIntro.vue": "./src/components/onBody/templalteIntro.vue",
	"./templateAge.vue": "./src/components/onBody/templateAge.vue",
	"./templateAgeGroup.vue": "./src/components/onBody/templateAgeGroup.vue",
	"./templateBodypart.vue": "./src/components/onBody/templateBodypart.vue",
	"./templateChart.vue": "./src/components/onBody/templateChart.vue",
	"./templateConfirm.vue": "./src/components/onBody/templateConfirm.vue",
	"./templateEmail.vue": "./src/components/onBody/templateEmail.vue",
	"./templateEmailConfirm.vue": "./src/components/onBody/templateEmailConfirm.vue",
	"./templateEventCalendar.vue": "./src/components/onBody/templateEventCalendar.vue",
	"./templateGenerate.vue": "./src/components/onBody/templateGenerate.vue",
	"./templateHeight.vue": "./src/components/onBody/templateHeight.vue",
	"./templateMultiOption.vue": "./src/components/onBody/templateMultiOption.vue",
	"./templateMultiTag.vue": "./src/components/onBody/templateMultiTag.vue",
	"./templateName.vue": "./src/components/onBody/templateName.vue",
	"./templatePromo.vue": "./src/components/onBody/templatePromo.vue",
	"./templateSayhi.vue": "./src/components/onBody/templateSayhi.vue",
	"./templateSider.vue": "./src/components/onBody/templateSider.vue",
	"./templateSingleOption.vue": "./src/components/onBody/templateSingleOption.vue",
	"./templateSingleOptionCard.vue": "./src/components/onBody/templateSingleOptionCard.vue",
	"./templateSingleOptionWithimg.vue": "./src/components/onBody/templateSingleOptionWithimg.vue",
	"./templateSummary.vue": "./src/components/onBody/templateSummary.vue",
	"./templateTargetWeight.vue": "./src/components/onBody/templateTargetWeight.vue",
	"./templateTransition.vue": "./src/components/onBody/templateTransition.vue",
	"./templateWeight.vue": "./src/components/onBody/templateWeight.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/onBody sync \\.vue$";